module.exports = __webpack_public_path__ + "img/avatar_12.79aa952d.svg";